const { B } = require('core-js/modules/_export');

let menuFirstTime = true;

$(document).ready(function () {
  $('.toggle').click(function () {
    if ($(this).find('#nav-icon').hasClass('open')) {
      closeNav();
    } else {
      openNav();
    }
  });

  $('.searchicon').click(function () {
    openNav();
    $('#search').focus();
  });
    $('.websearch').click(function () {
      let $stagingBanner = $('#staging-banner');
      let $adminBar = $('#wpadminbar');
      setTimeout(function () { 
        $('#desktop-menu').css('top', $('header').outerHeight() - $(window).scrollTop() + ($stagingBanner.length > 0 ? $stagingBanner.outerHeight() : 0) + ($adminBar.length > 0 ? $adminBar.outerHeight() : 0) + 'px');
      }, 200);
    });
});

function openNav() {
  $('#myNav').css('height', '100%');

  fixPosition();
  if (menuFirstTime) openMenuFirstTime();
  $('body').css('overflow-y', 'hidden');
  $('#myNav').css('overflow-y', 'scroll');

  $('#nav-icon').addClass('open');
  $('#desktop-menu').addClass('open');
  setTimeout(function () {
    $('#desktop-menu').css('overflow-y', 'scroll');
    $('#desktop-menu').css('height', '100%');
  }, 100);
}

function closeNav() {
  $('#myNav').css('height', '0');
  $('#desktop-menu').css('height', '0');
  $('body').css('overflow-y', 'auto');
  $('#nav-icon').removeClass('open');

  setTimeout(function () {
    $('#desktop-menu').removeClass('open');
  }, 500);
}

function fixPosition() {
  let siteTop = $('.site-top');
  let position;
  let $stagingBanner = $('#staging-banner');
  let $adminBar = $('#wpadminbar');
  position = $('header').outerHeight() - $(window).scrollTop() + ($stagingBanner.length > 0 ? $stagingBanner.outerHeight() : 0) + ($adminBar.length > 0 ? $adminBar.outerHeight() : 0);

  $('.mobile-menu-overlay').css('top', position + 'px');
  $('#desktop-menu').css('top', position + 'px');
}

function openMenuFirstTime() {
  let current = $('a.current-menu-item');
  if (current.length > 1) {
    current = $("a[href*='" + window.location.href + "']").first();
  }

  if (!current.is('.menu')) {
    current = current.parent().prev();
  }
  while (current.is('.menu')) {
    openMenu(current, false);
    current = current.parent().prev();
  }
  menuFirstTime = false;
}

$('a.menu').click(function () {
  let $this = $(this);
  openMenu($this, true);
});

function openMenu($this, animate) {
  let subMenu = $this.next();
  let duration = animate ? 300 : 0;

  animateArrow($this.find('.arrow').get(0), subMenu.is(':visible'), duration);
  if (subMenu.is(':visible')) {
    subMenu.hide(duration);
  } else {
    let menus = subMenu.parent().find('.sub-menu');
    menus.each(function () {
      if ($(this).is(':visible')) {
        animateArrow($(this).prev().find('.arrow').get(0), true, duration);
        $(this).hide(duration);
      }
    });
    subMenu.show(duration);
  }
  fixPosition();
}

function animateArrow(arrow, visible, duration) {
  anime({
    targets: arrow,
    rotate: { value: visible ? 45 : -135, duration: duration },
    easing: 'linear',
    complete: function (anim) {
      fixPosition();
    },
  });
}

function getMenuItemId(item) {
  let classList = item.attr('class').split(/\s+/);
  let searchPattern = new RegExp('^menu-item-\\d+');
  for (let pos = 0; pos < classList.length; pos++) {
    let className = classList[pos];
    if (searchPattern.test(className)) {
      return className.split('-', 3)[2];
    }
  }
}

function fixDuplicateMenus() {
  let menus = $('a.menu-item');
  let menuMap = {};
  let menuExist = {};
  menus.each(function () {
    let menu = $(this);
    let url = menu.get(0).href;
    if (url in menuExist) {
      if (url in menuMap) {
        menuMap[url].push(menu);
      } else {
        menuMap[url] = [menuExist[url], menu];
      }
    } else {
      menuExist[url] = menu;
    }
  });

  for (let url in menuMap) {
    for (let pos = 0; pos < menuMap[url].length; pos++) {
      let item = menuMap[url][pos];
      let id = getMenuItemId(item);
      item.get(0).href = item.get(0).href + '#' + id;
    }
  }
}

fixDuplicateMenus();

//Focus tabbing

$('.toggle').focus(function () {
  $(this).addClass('active');
});

$('.toggle').blur(function () {
  $(this).removeClass('active');
});

$('.site-menu li:last-of-type a').blur(function () {
  setTimeout(function () {
    if ($('.site-menu li:last-of-type').prev().children('a').is(':focus')) {
      //$('#desktop-menu').add('open');
    } else {
      $('#myNav').css('height', '0');
      $('#desktop-menu').css('height', '0');
      $('body').css('overflow-y', 'auto');
      $('#nav-icon').removeClass('open');

      setTimeout(function () {
        $('#desktop-menu').removeClass('open');
      }, 500);
    }
  }, 100);
});
